define.alias("ember-composable-helpers/helpers/slice", "settings/helpers/slice");